import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { ZodError, z } from 'zod'
import { UseFormReturn } from 'react-hook-form'
import { redirect } from 'next/navigation'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function flattenErrors(errors: ZodError): Record<string, string> {
  return Object.entries(z.treeifyError(errors)).reduce(
    (acc, [key, value]) => {
      acc[key] = value ? value[0] : ''
      return acc
    },
    {} as Record<string, string>,
  )
}

export function catchValidationError(error: ZodError): Record<string, string> {
  console.log(error)
  return flattenErrors(error)
}

export function getDirtyValues<T extends Record<string, unknown>>(
  form: UseFormReturn<T>,
  values: T,
): Partial<T> {
  const dirtyValues: Partial<T> = {}

  for (const field in form.formState.dirtyFields) {
    if (form.formState.dirtyFields[field]) {
      dirtyValues[field] = values[field]
    }
  }

  return dirtyValues
}

export function unauthorizedAction() {
  redirect('/auth/unauthorized')
}
